import { Component, inject, signal } from '@angular/core';
import { AppStateService } from '@core/states/app-state.service';
import { DropdownArrowComponent } from '../dropdown-arrow/dropdown-arrow.component';
import { CurrencyPair, getCurrencySymbol } from '@main/checkout/services/currency.service';

@Component({
    selector: 'app-currency-selector',
    standalone: true,
    imports: [DropdownArrowComponent],
    templateUrl: './currency-selector.component.html',
    styleUrl: './currency-selector.component.scss',
})
export class CurrencySelectorComponent {
    appStateService = inject(AppStateService);
    isOpen = signal(false);

    get exchangeRates (): CurrencyPair[] {
        return this.appStateService.getState().exchangeRates;
    }

    get selectedCurrency (): string {
        return this.appStateService.getState().selectedDisplayCurrency;
    }

    get defaultCurrency (): string {
        return this.appStateService.getState().currency;
    }

    get displayLabel (): string {
        if (this.selectedCurrency) {
            return `${this.getSymbol(this.selectedCurrency)} ${this.selectedCurrency}`;
        }
        return `${this.getSymbol(this.defaultCurrency)} ${this.defaultCurrency}`;
    }

    getSymbol (code: string): string {
        return getCurrencySymbol(code);
    }

    selectCurrency (currency: string) {
        this.appStateService.setDisplayCurrency(currency);
        this.isOpen.set(false);
    }

    toggleDropdown () {
        this.isOpen.update(v => !v);
    }

    closeDropdown () {
        this.isOpen.set(false);
    }
}
